// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import {CardinalAttachedEndpoint} from './cardinal-attached-endpoint.js'
import {FractionalAttachedEndpoint} from './fractional-attached-endpoint.js'
import {FreeEndpoint} from './free-endpoint.js'

export enum ConnectorEndpoint {
  NONE = 0,
  CardinalAttachedEndpoint = 1,
  FreeEndpoint = 2,
  FractionalAttachedEndpoint = 3
}

export function unionToConnectorEndpoint(
  type: ConnectorEndpoint,
  accessor: (
    obj: CardinalAttachedEndpoint | FractionalAttachedEndpoint | FreeEndpoint
  ) => CardinalAttachedEndpoint | FractionalAttachedEndpoint | FreeEndpoint | null
): CardinalAttachedEndpoint | FractionalAttachedEndpoint | FreeEndpoint | null {
  switch (ConnectorEndpoint[type]) {
    case 'NONE':
      return null
    case 'CardinalAttachedEndpoint':
      return accessor(new CardinalAttachedEndpoint())! as CardinalAttachedEndpoint
    case 'FreeEndpoint':
      return accessor(new FreeEndpoint())! as FreeEndpoint
    case 'FractionalAttachedEndpoint':
      return accessor(new FractionalAttachedEndpoint())! as FractionalAttachedEndpoint
    default:
      return null
  }
}

export function unionListToConnectorEndpoint(
  type: ConnectorEndpoint,
  accessor: (
    index: number,
    obj: CardinalAttachedEndpoint | FractionalAttachedEndpoint | FreeEndpoint
  ) => CardinalAttachedEndpoint | FractionalAttachedEndpoint | FreeEndpoint | null,
  index: number
): CardinalAttachedEndpoint | FractionalAttachedEndpoint | FreeEndpoint | null {
  switch (ConnectorEndpoint[type]) {
    case 'NONE':
      return null
    case 'CardinalAttachedEndpoint':
      return accessor(index, new CardinalAttachedEndpoint())! as CardinalAttachedEndpoint
    case 'FreeEndpoint':
      return accessor(index, new FreeEndpoint())! as FreeEndpoint
    case 'FractionalAttachedEndpoint':
      return accessor(index, new FractionalAttachedEndpoint())! as FractionalAttachedEndpoint
    default:
      return null
  }
}
